import React from "react";

const StepConnector = () => (
  <svg width="25" height="1" viewBox="0 0 25 1" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line y1="0.5" x2="25" y2="0.5" stroke="#C2C2C2" strokeDasharray="3 3" />
  </svg>
);

export default React.memo(StepConnector);
